import { useQuery } from '@tanstack/react-query'

import { transferServices } from '../transferServices'
import { SavingGoalByIDParams } from '../transferTypes'
import { QUERY_KEYS } from '@/constants/queryKeys'

/**
 * Hook to fetch single saving goal by ID
 */
export const useGetSavingGoal = (params: SavingGoalByIDParams) =>
  useQuery({
    queryKey: [QUERY_KEYS.SAVING_GOAL, params.saving_goal_id],
    queryFn: () => transferServices.getSavingGoal(params),
    enabled: !!params.saving_goal_id,
    staleTime: 60 * 5 * 1000, // 5 minutes
  })
